import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { filterPreset_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterTag_template } from "./filterTag_template";

declare const ko: any;

export class channelsPlaylistsList_template extends vnTemplate {
    protected availableForUseFilter: multipleSelector_template;
    protected filterDate: filterDate_template;
    protected filterPreset: filterPreset_template;
    protected filterSimple: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected channelFilter: filterTag_template;

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div id="list-references">
                <div class="sub-header filter-preset w-justify ">
                    ${this.filterPreset.getHtmlBuild()}
                </div>

                <div class="sub-header w-justify">
                    <div class="w-left">
                        ${this.availableForUseFilter.getHtmlBuild()}
                        ${this.channelFilter.getHtmlBuild()}
                        ${this.filterDate.getHtmlBuild()}
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-channels"></div>
                   <div id="selected-available-for-use"></div>
                </div>
            </div>

            <div class="list-header w-justify" >
                <div class="w-left" data-bind="if: isAddButtonShown">
                    <button data-bind="click: onClickAdd" class="btn secondary icon i-playlist" type="button">Add Playlist</button>
                </div>
                <div class="w-center">
                    ${this.filterSimple.getHtmlBuild()}
                </div>
                <div class="w-right">
                    ${this.pagination.getHtmlBuild()}
                </div>
            </div>

            <div class="w-list-results w-video-list list-article" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'description') }, css: { 'list-sort-desc': orderByAndDirection()=='description_DESC', 'list-sort-asc': orderByAndDirection()=='description_ASC' }">Description</span></th>
                            <th><span class="icon list-sort-none">Channel</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'availableForUse') }, css: { 'list-sort-desc': orderByAndDirection()=='availableForUse_DESC', 'list-sort-asc': orderByAndDirection()=='availableForUse_ASC' }">Available For Use</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                            <th><span>Delete</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: playlists">
                        <tr  class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.idBrand() + '/categorization/playlists/view/' + $data.id }">
                                    <span data-bind="text: id"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind = "attr: { href :   '/brand/' + $parent.idBrand() + '/categorization/playlists/view/' + $data.id }">
                                   <span data-bind="text: title"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind = "attr: { href :   '/brand/' + $parent.idBrand() + '/categorization/playlists/view/' + $data.id }">
                                   <span data-bind="text: description"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind = "attr: { href :   '/brand/' + $parent.idBrand() + '/categorization/playlists/view/' + $data.id }">
                                   <span data-bind="text: channelName"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind = "attr: { href :   '/brand/' + $parent.idBrand() + '/categorization/playlists/view/' + $data.id }">
                                   <span data-bind="text: availableForUse ? 'Yes' : 'No'"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.idBrand() + '/categorization/playlists/view/' + $data.id }">
                                    <span data-bind="text: dateCreated"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.idBrand() + '/categorization/playlists/view/' + $data.id }">
                                    <span data-bind="text: dateUpdated"></span>
                                </a>
                            </td>
                            <td>
                                <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="click: $parent.onClickDelete">
                                    <span class="hidden-text">Delete</span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            `;
    }

    protected getTemplateName(): string {
        return "channelsPlaylistsList_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected initPartial(): void {
        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType("playlists");

        this.availableForUseFilter = new multipleSelector_template(
            "availableForUseFilter",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.availableForUseFilter.setLabel("Available For Use");
        this.availableForUseFilter.setFilterContainerClass("margin-neg");
        this.availableForUseFilter.setTagContainerId("selected-available-for-use");
        this.availableForUseFilter.setTagContainerCaption("Available for use'");

        this.channelFilter = new filterTag_template("channelFilter", this.getTemplateViewModel(), this.caller);
        this.channelFilter.asMultipleSelectionMode();
        this.channelFilter.setShowType(false);
        this.channelFilter.setPlaceholderText("Channel");
        this.channelFilter.setTagContainerId("selected-channels");
        this.channelFilter.setTagContainerCaption("Channels");

        this.filterDate = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.filterDate.getTemplateViewModel().startDate(null);
        this.filterDate.getTemplateViewModel().endDate(null);
        this.filterDate.toggleClearButton(true);
        this.filterDate.setLabel("Date Range");

        this.filterSimple = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            idBrand: ko.observable(null),
            isAddButtonShown: ko.observable(true),
            orderBy: ko.observable("title"),
            orderByAndDirection: ko.observable("title_ASC"),
            orderByDirection: ko.observable("ASC"),
            permissions: ko.observableArray(this.initPermissions(["article_list_self", "article_list_brand"])),
            playlists: ko.observableArray([]),
            onClickAdd: () => {
                self.onClickAdd();
            },
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickView: (data, event) => {
                self.onClickView(data, event);
            },
            onClickDelete: (data, event) => {
                self.onClickDelete(data, event);
            },
        };
    }

    public getViewModelForRequest() {
        return {
            filters: {
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                channels: this.channelFilter.getTagsForRequest(),
                availableForUse: this.availableForUseFilter.getSelectedItems(),
            },
            orderBy: this.getTemplateViewModel().orderBy,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType(),
            pagination: this.getTemplateViewModel().pagination,
        };
    }

    public setViewModelFromRequest(urlParams) {
        if (urlParams != null) {
            if (urlParams.dateFilterType) {
                this.filterDate.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if (urlParams.startDateRange || urlParams.endDateRange) {
                this.filterDate.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }
            if (urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            let keywordString = urlParams.keywords;
            if (urlParams.keywords) {
                let string = urlParams.keywords;
                if (typeof string === "number") {
                    string = string.toString();
                }
                keywordString = string.replaceAll("+", " ");
            }
            this.filterSimple.getTemplateViewModel().filterKeyword(keywordString);

            if (urlParams.channels) {
                this.channelFilter.setSelectedTagsFromRequestParams(urlParams.channels);
            } else {
                this.channelFilter.resetTagContainer();
            }

            this.setFilterSelectedItems(this.availableForUseFilter, urlParams.availableForUse);
        }
    }

    public addCreatedPresetToList(response) {
        this.filterPreset.addCreatedPresetToList(response);
    }

    public buildDatePickerCalendar() {
        this.filterDate.buildCalendar();
    }

    public onClickAdd() {
        this.caller.addPlaylist();
    }

    public onClickReorder(value, data, event) {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.playlistsListReorder();
    }

    public onClickView(data, event) {
        if (event.target.id.indexOf("site-view") == -1) {
            this.caller.viewPlaylist(data.id);
        }
    }

    protected onClickDelete(data, event) {
        if (confirm("Are you sure you want to remove this playlist?") === true) {
            this.caller.delete(data);
        }
    }

    public setAddButtonShown(isAddButtonShown: boolean) {
        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    private setDateFilters(startDate, endDate) {
        if (startDate) {
            startDate = new Date(startDate.replace(/-/g, "/"));
        }
        if (endDate) {
            endDate = new Date(endDate.replace(/-/g, "/"));
        }
        this.filterDate.setDateRange(startDate, endDate);
    }

    public setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setSearchPresets(presets) {
        this.filterPreset.setSearchPresets(presets);
    }

    public setPlaylists(playlists: Array<{}>): void {
        this.getTemplateViewModel().playlists(playlists);
    }

    public setIdBrand(idBrand) {
        this.getTemplateViewModel().idBrand(idBrand);
    }

    private setTagPreset(idTag: number, tag: string): void {
        this.channelFilter.getTemplateViewModel().idTag(idTag);
        this.channelFilter.getTemplateViewModel().tag(tag);
    }

    protected setChannelFilter(channels) {
        this.channelFilter.setTags(channels);
    }

    public setAvailableForUseFilter(items) {
        this.availableForUseFilter.setItems(items);
    }

    public setFilterSelectedItems(objFilter, urlParams) {
        let splitString = [];

        // Multi select filters.
        if (Array.isArray(urlParams)) {
            urlParams = urlParams.toString();
        }
        if (urlParams) {
            if (typeof urlParams == "string") {
                splitString = urlParams.split(",");
            } else {
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if (!isNaN(Number(id))) {
                    id = Number(id);
                } else {
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        } else {
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/channelsPlaylistsList_template.ts